export default "__VITE_ASSET__BKr_XSo8__"